var _defs, _text, _text2, _text3, _text4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 144,
    viewBox: "0 0 460 144",
    id: "svg16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style4"
  }, "\n      .cls-1 {\n        font-size: 24px;\n      }\n      .cls-2 {\n        font-size: 30px;\n      }\n      .cls-1, .cls-2 {\n        font-family: \"Lucida Sans Unicode\";\n        fill=\"currentColor\";\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "\\u0414\\u0406\\u0422\\u042F\\u041C_\\u0417_\\u0423\\u041A\\u0420\\u0410\\u0407\\u041D\\u0418_bl",
    "data-name": "\\u0414\\u0406\\u0422\\u042F\\u041C \\u0417 \\u0423\\u041A\\u0420\\u0410\\u0407\\u041D\\u0418\\xBB bl",
    className: "cls-1",
    x: 122.17578,
    y: 134
  }, "\u0414\u0406\u0422\u042F\u041C \u0417 \u0423\u041A\u0420\u0410\u0407\u041D\u0418\xBB")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "_\\u0414\\u041E\\u041F\\u041E\\u041C\\u041E\\u0413\\u0410_\\u041F\\u041E\\u0421\\u0422\\u0420\\u0410\\u0416\\u0414\\u0410\\u041B\\u0418\\u041C_wt",
    "data-name": "\\xAB\\u0414\\u041E\\u041F\\u041E\\u041C\\u041E\\u0413\\u0410 \\u041F\\u041E\\u0421\\u0422\\u0420\\u0410\\u0416\\u0414\\u0410\\u041B\\u0418\\u041C wt",
    className: "cls-1",
    x: 49.308594,
    y: 99.320312
  }, "\xAB\u0414\u041E\u041F\u041E\u041C\u041E\u0413\u0410 \u041F\u041E\u0421\u0422\u0420\u0410\u0416\u0414\u0410\u041B\u0418\u041C")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "_\\u041C\\u0406\\u0416\\u041D\\u0410\\u0420\\u041E\\u0414\\u041D\\u0418\\u0419_\\u0411\\u041B\\u0410\\u0413\\u041E\\u0414\\u0406\\u0419\\u041D\\u0418\\u0419_\\u0424\\u041E\\u041D\\u0414_wt",
    "data-name": "\\xAB\\u041C\\u0406\\u0416\\u041D\\u0410\\u0420\\u041E\\u0414\\u041D\\u0418\\u0419 \\u0411\\u041B\\u0410\\u0413\\u041E\\u0414\\u0406\\u0419\\u041D\\u0418\\u0419 \\u0424\\u041E\\u041D\\u0414 wt",
    className: "cls-1",
    x: 4.5605469,
    y: 67.96875
  }, "\xAB\u041C\u0406\u0416\u041D\u0410\u0420\u041E\u0414\u041D\u0418\u0419 \u0411\u041B\u0410\u0413\u041E\u0414\u0406\u0419\u041D\u0418\u0419 \u0424\u041E\u041D\u0414")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "\\u0411\\u041B\\u0410\\u0413\\u041E\\u0414\\u0406\\u0419\\u041D\\u0410_\\u041E\\u0420\\u0413\\u0410\\u041D\\u0406\\u0417\\u0410\\u0426\\u0406\\u042F_bl",
    "data-name": "\\u0411\\u041B\\u0410\\u0413\\u041E\\u0414\\u0406\\u0419\\u041D\\u0410 \\u041E\\u0420\\u0413\\u0410\\u041D\\u0406\\u0417\\u0410\\u0426\\u0406\\u042F bl",
    className: "cls-2",
    x: 32.612305,
    y: 30.5
  }, "\u0411\u041B\u0410\u0413\u041E\u0414\u0406\u0419\u041D\u0410 \u041E\u0420\u0413\u0410\u041D\u0406\u0417\u0410\u0426\u0406\u042F")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoName);
export default __webpack_public_path__ + "static/media/co-name.ec87d94200ca1f1a6c12c8119f9488b8.svg";
export { ForwardRef as ReactComponent };